import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import { mapRedirectTargetToRoute, mapRedirectTargetToRouteFromApiName } from 'self-service-api/core/utilities/links';
import { SURVEY_OPTIONS_BY_UPGRADE_PRODUCT } from 'ui-addon-upgrades/_core/common/constants/trials';
import { trackBeforeUnload } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { navigateTo } from '../../common/navigation/url';
import { shuffle } from '../../../utils';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
const LANG_ROUTE = 'upgrades.activationModal';

const TrialRedirectSurvey = ({
  upgradeData,
  upgradeData: {
    upgradeProduct,
    apiName
  },
  canViewNewSeats = false
}) => {
  const surveyOptions = useMemo(() => shuffle(SURVEY_OPTIONS_BY_UPGRADE_PRODUCT[upgradeProduct]), [upgradeProduct]);

  const handleRedirect = value => {
    trackBeforeUnload('trialActivationRedirected', Object.assign({
      redirectTarget: value
    }, getUpgradeDataTrackingProperties(upgradeData), {
      trialId: upgradeData.trialId,
      duration: upgradeData.duration
    }));

    if (canViewNewSeats && apiName) {
      navigateTo(mapRedirectTargetToRouteFromApiName(value, apiName));
    } else {
      navigateTo(mapRedirectTargetToRoute(value, upgradeProduct));
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-6",
    style: {
      width: '100%'
    },
    children: [/*#__PURE__*/_jsx("h5", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${LANG_ROUTE}.featureExplore`
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      children: [surveyOptions.map(option => /*#__PURE__*/_jsx(UISelectableButton, {
        className: "m-bottom-2 display-inline-block text-left",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.survey.${option}.description`
        }),
        block: true,
        name: option,
        truncatable: false,
        onClick: () => handleRedirect(option)
      }, option)), /*#__PURE__*/_jsx(UISelectableButton, {
        className: "m-bottom-2 display-inline-block text-left",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}.survey.other`
        }),
        block: true,
        name: "other",
        truncatable: false,
        onClick: () => handleRedirect('other')
      })]
    })]
  });
};

TrialRedirectSurvey.propTypes = {
  upgradeData: PropTypes.object.isRequired,
  canViewNewSeats: PropTypes.bool
};
export default TrialRedirectSurvey;